import { useState, useEffect, useContext } from 'react';
import DialogCalidadRcp from '../DialogCalidadRcp/DialogCalidadRcp'
import DialogNoTecnicas from '../DialogNoTecnicas/DialogNoTecnicas'
import { TimelineContext } from '../../helpers/Context'
import Loader from '../Loader/Loader';




const DialogMedirAmbas = ({ callbackConfirm, callbackCancel, status }) => {

    const ctxTimeline = useContext(TimelineContext);
    const [isOpen, setIsOpen] = useState(status)
    const [isPopUpNoTecnicas, setIsPopUpNoTecnicas] = useState(true)
    const [isPopUpCalidadRcp, setIsPopUpCalidadRcp] = useState(false)
    const [loadingText, setLoadingText] = useState('Guardando informe...')
    const [isLoading, setIsLoading] = useState(false)


    

    const handlerClose = () => {
        if (callbackCancel) {
            callbackCancel()
        }
    }
    const handleOnConfirm = () => {
        if (callbackConfirm) {
            callbackConfirm()
        }
    }
    useEffect(() => {
        setIsOpen(status)
    }, [status])

    const handlerDialogStop = () => {
        setIsPopUpNoTecnicas(false)
        setIsPopUpCalidadRcp(false)

    }

	const handleVolverNoTecnicas = () => {
		
        handlerClose()
	}
 
	const handleVolverCalidadRcp = () => {
		setIsPopUpCalidadRcp(false)
	}

    return (
        <>
        <Loader status={isLoading} text={loadingText} />
            {isOpen &&
                <div>
                    <DialogNoTecnicas
                        callbackConfirm={()=>{
                            setIsPopUpNoTecnicas(false)
                            setIsPopUpCalidadRcp(true)
                        }}
                        callbackCancel={() => handlerDialogStop()}
                        status={isPopUpNoTecnicas}
                        volverNoTecnicas={() => handleVolverNoTecnicas()} 
                        saveAnd={"saveAndMesureRCP"}
                        noBackground
                    /> 
                    <DialogCalidadRcp
                        callbackConfirm={()=>{
                            setIsPopUpCalidadRcp(false)
                            handleOnConfirm()
                        }}
                        callbackCancel={()=>{
                            setIsPopUpNoTecnicas(true)
                            setIsPopUpCalidadRcp(false)
                        }}
                        status={isPopUpCalidadRcp}
                        volverCalidadRcp={() => handleVolverCalidadRcp()} 
                        saveAnd={"Guardar y generar informe"}
                        noBackground
                    /> 

                </div>
            }
        </>);
}

export default DialogMedirAmbas;